import { PortCall } from 'src/types/ViewModel/PortCall';
import { Port } from 'src/types/ViewModel/Port';
import { PortCallStatus } from 'src/enums/portCallStatus';
import { RotationTreeEnum } from 'src/enums/rotationTreeEnum';
import { ReportLocationEnum } from 'src/enums/reportLocationEnum';
import { StowagePlan } from 'src/types/ViewModel/Stowage/StowagePlan';
import { TimeZoneData } from 'src/types/ViewModel/TimeZoneData';
import { Rotation } from 'src/types/ViewModel/Rotation';

export const getAolPortCall = async (
    imoNumber: number,
    imosPortCallId: number,
    isStowageIntegrationActive: boolean,
    firstVoyageSync: number | null | undefined,
    loadedMasterStowagePlan: StowagePlan | null,
    timeZoneData: TimeZoneData | null,
    updatedRotation: Rotation | null,
    rotation: Rotation | null,
    getExtendedRotation: (imoNumber: number) => Promise<Rotation | undefined>
): Promise<PortCall | undefined> => {
    let portCall: PortCall | undefined;

    if (isStowageIntegrationActive && loadedMasterStowagePlan) {
        const stowagePortCall = loadedMasterStowagePlan.rotation.find((pc) => pc.imosPortCallId === imosPortCallId);
        if (stowagePortCall) {
            const voyageNum = parseInt(stowagePortCall.voyageNumber, 10);
            if (!firstVoyageSync || voyageNum >= firstVoyageSync) {
                const port = new Port(
                    stowagePortCall.portId,
                    stowagePortCall.portDisplayName,
                    '',
                    null,
                    [],
                    timeZoneData ? timeZoneData[stowagePortCall.portId] : [],
                    false
                );
                portCall = new PortCall(
                    stowagePortCall.imosPortCallId ?? null,
                    [],
                    null,
                    stowagePortCall.voyageNumber,
                    stowagePortCall.voyageNumber,
                    null,
                    stowagePortCall.portDisplayName,
                    null,
                    null,
                    false,
                    PortCallStatus.Tentative,
                    RotationTreeEnum.PortCall,
                    port,
                    0,
                    '',
                    false,
                    false,
                    false,
                    false,
                    false,
                    null,
                    null,
                    ReportLocationEnum.Port,
                    false,
                    null,
                    null,
                    null,
                    [],
                    null,
                    null,
                    null,
                    null
                );
            }
        }
    }

    if (!portCall) {
        portCall = updatedRotation?.portCallArray?.find((pc) => pc.portCallId === imosPortCallId);
    }

    if (!portCall && rotation) {
        portCall = rotation.portCallArray.find((pc) => pc.portCallId === imosPortCallId);
    }

    if (!portCall) {
        const loadedRotation = await getExtendedRotation(imoNumber);
        portCall = loadedRotation?.portCallArray?.find((pc) => pc.portCallId === imosPortCallId);
    }

    return portCall;
};
